import { PageState } from '../state';
import { createContext, useContext } from 'react';

const defaultValue = new PageState();
const context = createContext<PageState>(defaultValue);

export const pageContext = context;
export const PageContextProvider = context.Provider;
export const PageContextConsumer = context.Consumer;

export const usePageContext = () => {
  const value = useContext(context);

  if (process.env.NODE_ENV === 'development' && value === defaultValue) {
    console.warn('Wrap your component with CollectionPage or PageWrapper');
  }

  return value;
};
